import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-host Inter + JetBrains Mono via @fontsource-variable (single woff2
// per family covers all weights). Imported BEFORE tokens.css so the
// @font-face declarations are registered before --font-sans is read.
// Per design/UI : UX v1.0/for-engineering-fonts/for-engineering-system/
// FONTS.md (EU/GDPR posture — no Google CDN calls in production).
import '@fontsource-variable/inter';
import '@fontsource-variable/jetbrains-mono';

import '@gc-coach/design-system/tokens.css';
import './styles/global.css';

import { App } from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
